import $ from "jquery";
import compile from "@bd-utils/handlerbars-helper";
import BD_Component from "@bd-core/bd-component";
import "jquery-ui-dist/jquery-ui";
import CONFIG from "@bd-core/config";
import GameLogic from "@bd-core/game-logic";
import { getState } from "@bd-stores/store";
import { getRoomStatus, getFinalTeamAnswers, getRoomStartedAt } from "@bd-stores/game-progress";
import { getRoomAnswerById } from "@bd-stores/game-data";
import CompletionPopup from "@bd-utils/completion-popup";
import {
    saveFinalRoomAnswers,
    setMiddleState,
    maybeUpdateRoomStatus,
    updateRoomAnswer,
    getRoomAnswers,
    addDocument,
} from "@bd-core/firebase-actions";

export class RoomMatchCard extends BD_Component {
    constructor() {
        super();

        this.id = "match_card";
        this.templateID = "match_card-template";
        this.elms = {
            blur: ".app-blur",
            matchCardItem: ".js-matchCard-item",
            matchCardAnswerBtn: ".js-matchCard-answer",
            matchCardClearAnswerBtn: ".js-matchCard-clear-answer",
            matchCardSelectBtn: ".js-matchCard-select",
            matchCardAudioBtn: ".js-matchCard-audio",
            matchOverlay: ".js-matchCard-overlay",
            matchOverlayClose: ".js-matchOverlay-close",
            slotAnswerImage: ".js-match-answer-image",
            submitBtn: ".js-submit",
            check: ".check__result",
            shareBtn: ".js-share-btn",
            securityNumberBtn: ".js-security-number-btn",
            digitLabel: ".js-digit",
            submtiSecurity: ".js-submit-security",
            removeCardDrop: ".js-matchCard-remove",
            scrollTriggerLast: ".js-scroll-cards-end",
            scrollTriggerFirst: ".js-scroll-cards-start",
            cardsList: ".available-cards__list",
            pointerBtn: ".js-pointer",
            closePopupBtn: ".js-close-popup",
            imageBox: ".js-imagebox",
            imageBoxFullscreen: ".js-imagebox-fullscreen",
            openFullscreenBtn: ".js-open-imagebox-fullscreen",
            closeFullscreenBtn: ".js-close-popup-fullscreen",
            imageBoxImg: ".js-imagebox-img",
            snackbar: ".js-saved-document-snackbar",
            closeSnackbar: ".js-close-snackbar",
            hintItems: ".js-hints-item",
            hintTimerBox: ".js-hint-timer-box",
            hintTimer: ".js-hint-timer",
            hintCounter: ".js-hint-counter",
            result: ".matchCards__result",
            resultCircleCorrect: ".result__circle--correct span.count",
            resultCircleWrong: ".result__circle--wrong span.count",
        };

        this._events = this.getEvents();

        /**
         * @type {Array<HTMLAudioElement>}
         */
        this.audios = [];

        /**
         * @type {BD_RoomMatchCards}
         */
        this._data = undefined;

        this.userAnswer = undefined;

        this.useMiddleState = true;

        this.completionPopup = new CompletionPopup();

        this.currentSecurityIndex = 0;

        this.preFilled = [];

        this.meSubmittingAnswer = false;

        this.hintInterval = null;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.submitBtn,
                handler: this.onSubmitAnswer,
            },
            {
                event: "click",
                selector: elms.matchCardAudioBtn,
                handler: this.onPlayAudio,
            },
            {
                event: "click",
                selector: `${elms.matchCardAnswerBtn}, ${elms.matchOverlayClose}`,
                handler: this.onToggleMatchOverlay,
            },
            {
                event: "click",
                selector: elms.matchCardSelectBtn,
                handler: this.onSelectCard,
            },
            {
                event: "click",
                selector: elms.matchCardClearAnswerBtn,
                handler: this.onClearAnswer,
            },
            {
                event: "click",
                selector: elms.shareBtn,
                handler: this.onAddDocument,
            },
            {
                event: "click",
                selector: elms.securityNumberBtn,
                handler: this.onClickSecurityNumber,
            },
            {
                event: "click",
                selector: elms.submtiSecurity,
                handler: this.onSubmitSecurityNumber,
            },
            {
                event: "click",
                selector: elms.removeCardDrop,
                handler: this.onRemoveCardDrop,
            },
            {
                event: "click",
                selector: elms.pointerBtn,
                handler: this.onHandlePointer,
            },
            {
                event: "click",
                selector: elms.closePopupBtn,
                handler: this.onCloseImagePopup,
            },
            {
                event: "click",
                selector: elms.openFullscreenBtn,
                handler: this.handleFullscreen,
            },
            {
                event: "click",
                selector: elms.closeFullscreenBtn,
                handler: this.onCloseFullsceenPopup,
            },
            {
                event: "mousedown",
                selector: ".js-available-cards-item",
                handler: this.handleOnDraggingCard,
            },
            {
                event: "click",
                selector: elms.scrollTriggerLast,
                handler: this.onScrollToLast,
            },
            {
                event: "click",
                selector: elms.scrollTriggerFirst,
                handler: this.onScrollToFirst,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.renderPlayRoom();
        this.setupDraggable();
        this.setupDroppable();
        this.registerSounds();
        this.setGameState();
    }

    getModifiedData() {
        const modified = { ...this._data };
        const hotspots = modified["hotspots"];

        const slotImages = modified["slot_images"];
        // const usedImages = [...slotImages];

        for (const key in modified) {
            if (key.startsWith("grid_") && Array.isArray(modified[key])) {
                modified[key] = modified[key].map((item) => {
                    return item;
                });
            }
        }

        const updatedSlotImages = slotImages.map((img) => {
            return {
                ...img,
                is_used: this.preFilled.includes(img.slot_id),
            };
        });

        const hintHotspots = hotspots.filter(
            (hotspot) => hotspot["hotspot_type"] === "hint",
        );

        const docsHotspot = this._data.hotspots.filter(
            (h) => h["hotspot_type"] === "document",
        );

        const hotspotCount = hintHotspots.length;
        const defaultValue = "50%";
        const _hints = this._data.hints.map((hint, i) => {
            return {
                ...hint,
                position_top:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_top
                        : defaultValue,
                position_left:
                    hotspotCount > 0 && hintHotspots[i]
                        ? hintHotspots[i].position_left
                        : defaultValue,
            };
        });

        const _documents = this._data.documents.map((doc) => {
            const { document_id } = doc;
            const position = docsHotspot.find(
                (doc) => doc["document_id"] === document_id,
            );
            const position_top = position
                ? position["position_top"]
                : defaultValue;
            const position_left = position
                ? position["position_left"]
                : defaultValue;

            return {
                ...doc,
                position_top,
                position_left,
            };
        });

        const modifiedData = {
            ...modified,
            hints: _hints,
            slots: updatedSlotImages,
            documents: _documents,
            // image_bg: _image_bg,
            // slots: newSlots,
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();
        const isForcedOpenChallenge = modifiedData["force_open_challenge"];

        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);

        $(".app").html(html);

        if (isForcedOpenChallenge) {
            // this.onForceOppenChallenge();
        }

        $(".app__back").css("z-index", "1001");
    }

    renderPlayRoom() {
        const startedAt = +new Date();
        const $playroom = $(".playroom").last();
        const $playroomImage = $playroom.find(".playroom-image");
        const $playroomWrapper = $playroom.find(".playroom-wrapper");

        if (!$playroom) return;

        // show error if onLoad not called more than 10s
        const waitLoad = setInterval(() => {
            const now = +new Date();
            const diff = now - startedAt;
            if (diff > 10 * 1000) {
                // showMessage(viewData.strings.playroom_image_error_load);
                clearInterval(waitLoad);
            }
        }, 100);

        const calculate = () => {
            const imageRatio = $playroomImage.height() / $playroomImage.width();
            const containerRatio = $playroom.height() / $playroom.width();

            let finalHeight;
            let finalWidth;

            if (containerRatio > imageRatio) {
                finalHeight = $playroom.height();
                finalWidth = $playroom.height() / imageRatio;
            } else {
                finalWidth = $playroom.width();
                finalHeight = $playroom.width() * imageRatio;
            }

            $playroomWrapper.css({
                height: finalHeight + "px",
                width: finalWidth + "px",
            });

            $playroomImage.css({
                height: finalHeight + "px",
                width: finalWidth + "px",
            });

            $playroom.addClass("is-calculated");
        };

        const markAsLoaded = () => {
            clearInterval(waitLoad);
        };

        const onLoad = () => {
            calculate();
            markAsLoaded();
        };

        // if image loaded directly from cached file, it wont trigger onload
        // @ts-ignore
        // if ($playroomImage[0].complete) onLoad();
        $playroomImage.on("load", onLoad);
    }

    onForceOppenChallenge() {
        const elms = this.elms.questionPopup;
        const closeButton = this.elms.closeButtonPopup;
        const backButton = this.elms.backButton;

        const blur = $(".app-blur");

        blur.addClass("is-blurred");

        $(elms).addClass("is-open");
        $(closeButton).addClass("hidden");
        $(backButton).addClass("up-front");
    }

    setGameState() {
        const roomId = this.roomId;
        const thisRoomStatus = getRoomStatus(roomId);
        const roomAnswers = getFinalTeamAnswers(roomId);
        const elms = this.elms;
        const $matchCardItem = $(`.js-matchCard-item.ui-droppable`);
        const $matchCardItems = $(elms.matchCardItem);
        const slotImages = this._data.slot_images;
        let isMiddleState = false;

        const possibleStatuses = [
            "is-status-open",
            "is-status-started",
            "is-status-completed",
        ];

        if (thisRoomStatus) {
            const $status = $(".js-room-status");
            $status.removeClass(possibleStatuses);
            $status.addClass(thisRoomStatus);
        }

        if (roomAnswers) {
            $.each(roomAnswers, this.setViewAnswer.bind(this));

            isMiddleState = Object.values(roomAnswers).find(
                (value) => value.isMiddleState === true,
            )
                ? true
                : isMiddleState;

            if (thisRoomStatus == "is-status-completed") {
                if (!this.meSubmittingAnswer)
                    $(elms.check).removeClass("is-shown");

                $(elms.submitBtn).parent().parent().addClass("is-completed");
                $(".js-lockpad").removeClass("is-active");
                $matchCardItems.addClass("is-correct");
                $(".app__page").addClass("is-room-completed");
                $(".available-cards__item").hide();

                /* Show completion popup */
                this.completionPopup.show(roomId, isMiddleState, roomAnswers);
            }

            $matchCardItem.each(function (index, elm) {
                const $item = $(elm);
                const grid = $item.attr("data-grid");
                const answer = roomAnswers?.[grid]?.[$item.attr("data-id")];
                const theImage = slotImages.find(
                    (item) => Number(item.id) === answer,
                );

                if(theImage) {
                    const newImageAlt = theImage?.image_title || "Card image";

                    $item.addClass("is-dropped");
                    $item.attr("data-answer", answer);
                    $item.attr("data-image", theImage.url);

                    $item.find("img.card-drop__img")
                        .attr("src", theImage.url)
                        .attr("alt", newImageAlt);

                    $item.find("img.card-drop__connector")
                        .attr("src", theImage.connector_url)
                        .attr("alt", newImageAlt);
                }
            });

            // @ts-ignore
            // if (thisRoomStatus === "is-status-started" && !this.meSubmittingAnswer) {
                if (thisRoomStatus === "is-status-started") {
                $(".js-lockpad").removeClass("is-active");
                $(".app__back").css("z-index", "1");

                // getRoomAnswers(roomId).then((data) => {
                //     this.updateTempAnswers(data.val());
                // });
            }
        }

        this.handleHintVisibility();
    }

    handleHintVisibility() {
        const elms = this.elms;
        const $hintItems = $(elms.hintItems);
        const hintCount = $hintItems.length;
        let currentHintIndex = 0;
        const $firstHint = $hintItems.first();
        let hintTimerToActive = Number($firstHint.attr("data-timer"));
        const roomStartedAt = getRoomStartedAt(this.roomId, CONFIG.user.id);
        if(!roomStartedAt) return;

        if(hintCount === 0) return;

        if(this.hintInterval) {
            clearInterval(this.hintInterval);
            this.hintInterval = null;
        }

        const checkHints = () => {
            const now = Date.now();
            const minutesPassed = Math.floor((now - roomStartedAt) / 60000); //convert ms to minutes
            // let hintActiveId = null;

            $hintItems.each(function (index) {
                const $this = $(this);
                const hintTimer = Number($this.attr("data-timer"));
                if(minutesPassed >= hintTimer) {
                    // $hintItems.addClass("hidden");
                    $this.removeClass("hidden");
                    // hintActiveId = $this.attr("data-id");
                    const $nextHint = $this.next();
                    hintTimerToActive = $nextHint.length ? Number($nextHint.attr("data-timer")) : 0;
                    currentHintIndex = index + 1;
                }
            });

            if(hintTimerToActive > 0) {
                const nextHintTimer = hintTimerToActive;
                const nextHintTimerInMs = (nextHintTimer * 60000 + roomStartedAt) - now;
                const minutesToNextHint = Math.floor(nextHintTimerInMs / 60000);
                const secondsToNextHint = Math.floor((nextHintTimerInMs % 60000) / 1000);
                const minutesTxt = minutesToNextHint < 10 ? `0${minutesToNextHint}` : minutesToNextHint;
                const secondsTxt = secondsToNextHint < 10 ? `0${secondsToNextHint}` : secondsToNextHint;
                const nextHintTimerText =  `${minutesTxt}:${secondsTxt}`;

                $(elms.hintTimer).text(nextHintTimerText);
            }

            const nextHintCounter = `${currentHintIndex}/${hintCount}`;
            $(elms.hintCounter).text(nextHintCounter);

            // if last hint, hide timer box and clear interval
            if(currentHintIndex === hintCount) {
                $(elms.hintTimerBox).addClass("hidden");
                clearInterval(this.hintInterval);
            }
        }

        // Run immediately on page load
        checkHints();

        // Run every seconds
        this.hintInterval = setInterval(checkHints, 1000);
    }

    // ============================== CUSTOM FUNCTION

    onHandlePointer(e) {
        const elms = this.elms;
        const $this = $(e.currentTarget);
        const $imagebox = $(elms.imageBox);
        const $title = $(".playroom-imagebox-title");
        const $description = $(".playroom-imagebox-description");
        const $image = $(".playroom-imagebox-image");
        const title = $this.attr("data-title");
        const docId = $this.attr("data-id");
        const description = $this.data("description");
        const image = $this.data("image");
        const isFullscreen = $this.hasClass("is-fullscreen");
        const newImage = new Image();

        // This is to determine whether tutorial can be shown or not
        // because Tutorial should only be open only if $imagebox is open
        // and $image has been loaded successfully
        // `I` stands for `imagebox`
        // let hasIOpened = false;
        // let hasILoaded = false;

        // const onFinishTransition = () => {
        //     // Prevent prematurely show tutorial when the email hasn't open yet
        //     if (!$imagebox.hasClass('is-open')) return false;

        //     hasIOpened = true;
        //     // showTutorial();
        // };

        // const transitionEndEvent = getTransitionEndEvent();
        // $imagebox.on(transitionEndEvent, onFinishTransition);

        newImage.src = image;
        newImage.onload = function () {
            $image.removeClass("is-loading");
            // hasILoaded = true;
            // showTutorial();
        };

        if (isFullscreen) {
            $imagebox.addClass("is-fullscreen");
        } else {
            $imagebox.removeClass("is-fullscreen");
        }

        $title.html(title);
        $description.html(description);
        $image.find("img").remove();
        $image.addClass("is-loading").append(newImage);
        $imagebox.addClass("is-open");

        $(elms.shareBtn).attr("data-id", docId);
        $(elms.shareBtn).attr("data-url", image);
        $(elms.shareBtn).attr("data-title", title);
    }

    onCloseImagePopup() {
        $(this.elms.imageBox).removeClass("is-open");
    }

    onScrollToLast() {
        $(this.elms.cardsList).animate({ scrollLeft: 3000 }, 600);
        $(this.elms.scrollTrigger).fadeOut(100);
    }

    onScrollToFirst() {
        $(this.elms.cardsList).animate({ scrollLeft: 0 }, 600);
        $(this.elms.scrollTrigger).fadeIn(100);
    }

    handleFullscreen() {
        const elms = this.elms;
        const $selectedImg = $(elms.imageBoxImg).find("img");
        const $imageboxFullscreen = $(elms.imageBoxFullscreen);
        const $fullscreenWrapper = $imageboxFullscreen.find(
            ".popup-fullscreen-wrapper",
        );
        const $existingImg = $fullscreenWrapper.find("img");

        if ($existingImg.length) {
            $existingImg.removeClass("is-active");
            $existingImg.remove();
        }

        $selectedImg
            .clone(true)
            .addClass("is-active")
            .appendTo($fullscreenWrapper);
        $imageboxFullscreen.addClass("is-open");
    }

    onCloseFullsceenPopup() {
        const elms = this.elms;
        const $imageboxFullscreen = $(elms.imageBoxFullscreen);
        $imageboxFullscreen.removeClass("is-open");
    }

    registerSounds() {
        const elms = this.elms;
        const self = this;

        if (this.audios.length) {
            return false;
        }

        const $elBtnAudios = $(elms.matchCardAudioBtn);

        $.each($elBtnAudios, function (index, elBtnAudio) {
            const $audio = $(elBtnAudio);
            const audioUrl = $audio.attr("data-audio");
            const id = $audio.parents(elms.matchCardItem).attr("data-key");
            if (audioUrl) {
                const audio = new Audio(audioUrl);
                audio.id = id;
                self.audios.push(audio);
            }
        });
    }

    /**
     * Decide whether to disabled or enabled boolean action (Check btn)
     * @returns {Boolean}
     */
    toggleCheckButton() {
        const elms = this.elms;
        let isAnsweredAll = true;

        if ($(elms.submitBtn).hasClass("is-completed")) return false;

        $(elms.matchCardItem).each(function () {
            const isThisAnswered = $(this).hasClass("is-filled");
            if (!isThisAnswered) return (isAnsweredAll = false);
        });

        $(elms.submitBtn).prop("disabled", !isAnsweredAll);
        return isAnsweredAll;
    }

    handleOnDraggingCard() {
        this.meSubmittingAnswer = true;
    }

    setupDraggable() {
        const self = this;
        // const isTeamLeader = CONFIG.game.is_leader;
        // @ts-ignore
        $(".available-cards__item").draggable({
            containment: ".drag-drop-layer",
            stack: "#drop-area .drop-container .drop-item",
            cursor: "pointer",
            scroll: true,
            helper: "clone",
            revert: "valid",

            start: function (event, ui) {
                // if (!isTeamLeader) {
                //     return;
                // }

                // setDraggingAttributes(self.roomId, true, CONFIG.user.id);
                // self.isDragging = true;

                if (ui.helper.closest("#cards-stack").length === 0) {
                    return;
                }

                const $this = $(this);
                ui.helper.data("dropped", false);
                ui.helper.data("id", $this.attr("data-id"));

                // @ts-ignore
                $this.draggable("instance").offset.click = {
                    left: Math.floor(ui.helper.width() / 2),
                    top: Math.floor(ui.helper.height() / 2),
                };
            },

            stop: function (event, ui) {
                const isValidDrop = ui.helper.data("dropped");

                if (
                    !isValidDrop &&
                    ui.helper.closest("#cards-stack").length !== 0
                ) {
                    $(this).removeClass("dropped").css("margin-top", "0px");
                }
                // Check value of ui.helper.data('dropped') and handle accordingly...

                // setDraggingAttributes(self.roomId, false, CONFIG.user.id);
                // self.meSubmittingAnswer = false;

                // fix : dragging state not updated on release card, on `mouseup` event does not triggered when release the card on the edge of screen
                // if (self.isDragging) {
                //     self.handleCardReleaseClick();
                // }

                if (!ui.helper.data("dropped")) {
                    self.meSubmittingAnswer = false;
                }
            },

            drag: function (event, ui) {
                const $overlay = $(".general-overlay");
                if ($overlay.hasClass("is-active")) {
                    ui.helper
                        .draggable("option", "revert", true)
                        .trigger("mouseup");
                    return;
                }
            },
        });
    }

    setupDroppable() {
        const self = this;

        // @ts-ignore
        $(".card-drop").droppable({
            accept: ".available-cards__item",
            drop: function (event, ui) {
                const $overlay = $(".general-overlay");
                if ($overlay.hasClass("is-active")) {
                    return;
                }

                if ($(this).hasClass("is-dropped")) {
                    // alert("please remove card first!");
                    // return;

                    const oldAnswerId = $(this).attr("data-answer");
                    const $hiddenCard = $(
                        '.available-cards__item[data-id="' + oldAnswerId + '"]',
                    );

                   $hiddenCard.show();
                }

                $(this).addClass("is-dropped");
                self.handlerItemDrop(event, ui);
            },
            revert: "valid",
        });
    }

    handlerItemDrop(event, ui) {
        const $dropTarget = $(event.target);
        const $draggedItem = $(ui.draggable);
        const slotImages = this._data.slot_images;

        const newImageTitle = $draggedItem.find("img").attr("alt");
        const dataId = Number($draggedItem.data("id"));

        const targetData = slotImages.find(
            (item) => Number(item.id) === dataId,
        );
        if (targetData) {
            const newImageUrl = targetData.url;
            const newConnectorUrl = targetData.connector_url;
            const newImageAlt = targetData.image_title || "Card image";

            $dropTarget.attr("data-image", newImageUrl);

            $dropTarget
                .find("img.card-drop__img")
                .attr("src", newImageUrl)
                .attr("alt", newImageAlt);

            $dropTarget
                .find("img.card-drop__connector")
                .attr("src", newConnectorUrl)
                .attr("alt", newImageAlt);

            $dropTarget.attr("data-answer", dataId);
        }

        $dropTarget.attr("title", newImageTitle);
        $dropTarget
            .find(".matchCards__options--item-title")
            .text(newImageTitle);
        $dropTarget.find(".matchCards__options--item-description").text("");

        // const cardId = $dropTarget.attr("data-id");

        // this.setTempAnswers(cardId, dataId);

        $draggedItem.hide();
    }

    setTempAnswers(cardId, answer) {
        const isTeamLeader = CONFIG.game.is_leader;
        if(!isTeamLeader) {
            return;
        }

        const self = this;
        const roomId = self.roomId;
        const answerData = {
            [cardId]: answer,
        }

        getRoomAnswers(roomId).then((data) => {
            const userAnswer = data.val() ?? {};
            const theAnswer = { ...userAnswer, ...answerData };

            updateRoomAnswer(roomId, theAnswer)
            .then(() => (self.meSubmittingAnswer = false))
            .catch();
        });
    }

    removeTempAnswers(cardId) {
        const isTeamLeader = CONFIG.game.is_leader;
        if(!isTeamLeader) {
            return;
        }

        const roomId = this.roomId;
        getRoomAnswers(roomId).then((data) => {
            const userAnswer = data.val();

            delete userAnswer[cardId]?.answer;

            updateRoomAnswer(roomId, userAnswer);
        });
    }

    updateTempAnswers(answers) {
        const tempAnswers = answers || {};
        const $matchCardItem = $(`.js-matchCard-item.ui-droppable`);
        const slotImages = this._data.slot_images;
        
        $matchCardItem.each(function (index, elm) {
            const $item = $(elm);
            const answer = tempAnswers?.[$item.attr("data-id")];

            if(answer) {
                const theImage = slotImages.find(
                    (item) => Number(item.id) === answer,
                );

                if(theImage) {
                    const newImageAlt = theImage?.image_title || "Card image";
    
                    $item.addClass("is-dropped");
                    $item.attr("data-answer", answer);
                    $item.attr("data-image", theImage.url);
    
                    $item.find("img.card-drop__img")
                        .attr("src", theImage.url)
                        .attr("alt", newImageAlt);
    
                    $item.find("img.card-drop__connector")
                        .attr("src", theImage.connector_url)
                        .attr("alt", newImageAlt);
                }
            } else {
                $item.removeClass("is-dropped");
                $item.removeAttr("data-answer");
                $item.find("img.card-drop__img").removeAttr("src");
                $item.find("img.card-drop__connector").removeAttr("src");
            }
        });
    }

    onToggleMatchOverlay(e, el) {
        const elms = this.elms;
        const $matchOverlay = $(elms.matchOverlay);
        const isOpen = $(elms.matchOverlay).hasClass("is-open");

        $matchOverlay.toggleClass("is-open", !isOpen);

        if (!isOpen) {
            const $matchcard = $(el).parents(elms.matchCardItem);
            const key = $matchcard.attr("data-key");
            $matchOverlay.attr("data-active-key", key);
            $matchOverlay
                .find(".matchCards__options--item")
                .removeClass("active");
            // $matchOverlay
            //     .find(
            //         '.matchCards__options--item[data-active-key="' + key + '"',
            //     )
            //     .addClass("active");

            $(elms.blur).addClass("is-blurred");
            $(".timer").addClass("is-top");
        } else {
            $(elms.blur).removeClass("is-blurred");
            $(".timer").removeClass("is-top");
        }
    }

    onSubmitAnswer(e, el) {
        const elms = this.elms;
        const $el = $(el);
        const $result = $el.siblings(".challenge__result");
        const sttCompleted = "is-status-completed";
        // const isTeamLeader = CONFIG.game.is_leader;

        // if(!isTeamLeader) {
        //     return;
        // }

        if (
            $el.hasClass("is-loading") ||
            $el.hasClass("is-completed") ||
            sttCompleted === getRoomStatus(this.roomId)
        ) {
            return;
        }

        $result.removeClass("is-shown");
        $el.addClass("is-loading").prop("disabled", true);

        const roomID = this.roomId;
        const $matchCardItems = $(elms.matchCardItem);
        let roomAnswers = getRoomAnswerById(roomID);
        roomAnswers = roomAnswers?.answer || {};

        let roomStatus = "is-status-started";
        let playerAnswers = {};
        let correct = 0;
        let wrong = 0;
        let isMiddleState = false;

        $.each($matchCardItems, function (index, item) {
            const $item = $(item);
            const cardId = $item.attr("data-id");
            const answer = $item.attr("data-answer");
            const grid = $item.attr("data-grid");

            // Initialize the nested object if it doesn't exist
            if (!playerAnswers[grid]) {
                playerAnswers[grid] = {};
            }

            playerAnswers[grid][cardId] = Number(answer);
        });

        for (const key in playerAnswers) {
            const roomAnswer = roomAnswers[key];
            const roomAnswersValues = Object
                .values(roomAnswer);

            for (const value of Object.values(playerAnswers[key])) {
                // let status = "";

                if(roomAnswersValues.includes(value)) {
                    correct++;
                    // status = "is-correct";
                } else {
                    wrong++;
                    // status = "is-false";
                }

                // $(elms.matchCardItem + `[data-answer="${value}"]`)
                //     .addClass(status);
            }
        }

        $(elms.resultCircleCorrect).text(correct);
        $(elms.resultCircleWrong).text(wrong);
        $(elms.result).addClass("is-visible");

        const isAllCorrect = 
                (wrong === 0) 
                && (correct === $matchCardItems.length);

        $result.addClass("is-shown");

        $result.find(".result--correct span.count").text(correct);
        $result.find(".result--wrong span.count").text(wrong);

        $el.removeClass("is-loading").removeAttr("disabled");

        if (isAllCorrect) {
            roomStatus = sttCompleted;
            this.meSubmittingAnswer = true; // a flag to set the UI state

            if (isMiddleState) setMiddleState(roomID);

            const onSuccess = () => {
                $el.parent().parent().addClass("is-completed");
                $(".app__page").addClass("is-room-completed");
            };

            saveFinalRoomAnswers(roomID, playerAnswers)
                .then(onSuccess)
                .catch(() => (this.meSubmittingAnswer = false));
        } else {
            setTimeout(() => {
                // $matchCardItems.removeClass("is-false");
                // $matchCardItems.removeClass("is-correct");
                $(elms.result).removeClass("is-visible");
            }, 3000);
        }

        maybeUpdateRoomStatus(roomID, roomStatus);
    }

    onPlayAudio(e, el) {
        const elms = this.elms;
        const $el = $(el);
        const id = $el
            .parents(elms.matchCardItem)
            .attr("data-key");

        this.playPauseAudio(id, el);
    }

    playPauseAudio(id, btnEl = null) {
        /** @type {HTMLAudioElement | undefined} */
        let theAudio;

        const elms = this.elms;
        const $matchCardItem = btnEl
            ? $(btnEl).parents(elms.matchCardItem)
            : false;

        $.each(this.audios, function (index, audio) {
            if (audio.id == id) {
                theAudio = audio;
            } else {
                if (!audio.paused) {
                    try {
                        audio.pause();
                        $(elms.matchCardItem).removeClass("is-playing");
                    } catch (error) {
                        console.error(error);
                    }
                }
            }
        });

        if (theAudio) {
            try {
                if (!theAudio.paused) {
                    theAudio.pause();
                    if ($matchCardItem)
                        $matchCardItem.removeClass("is-playing");

                    GameLogic.backgroundAudio.play();
                } else {
                    theAudio.play();

                    GameLogic.backgroundAudio.pause();

                    if ($matchCardItem) {
                        $(theAudio).on("ended", function () {
                            $matchCardItem.removeClass("is-playing");
                        });

                        $matchCardItem.addClass("is-playing");
                    }
                }
            } catch (error) {
                console.error(error);
            }
        }
    }

    onSelectCard(e, el) {
        const elms = this.elms;
        const $el = $(el);

        const $matchoverlay = $el.parents(elms.matchOverlay);
        const key = $matchoverlay.attr("data-active-key");
        const chosenId = $el.attr("data-id");
        const isChosenMultiple = $el.attr("data-chosen-multiple") ?? false;
        const isSelected = $el.hasClass("is-selected");
        const hasSelected = !isSelected;

        const $sameCards = $(
            elms.matchCardItem + `.is-filled[data-answer="${chosenId}"]`,
        );

        if ($sameCards.length) {
            if (!isChosenMultiple) {
                $sameCards
                    .removeAttr("data-answer")
                    .removeClass("is-filled")
                    .find(elms.slotAnswerImage)
                    .removeAttr("src");
            }
        }

        this.setViewAnswer(key, chosenId);

        $el.toggleClass("is-selected", hasSelected);
        $matchoverlay.removeClass("is-open");
        $(elms.blur).removeClass("is-blurred");
        $(".timer").removeClass("is-top");

        const answerData = {
            [key]: chosenId,
        };

        this.userAnswer = answerData;

        this.updateUserAnswer();

        this.toggleCheckButton();
    }

    setViewAnswer(key, answerValue) {
        const elms = this.elms;
        const $cardItem = $(elms.matchCardItem + `[data-key="${key}"]`);
        const theAnswer = answerValue?.answer || answerValue;
        const $answer = $(elms.matchCardSelectBtn + `[data-id="${theAnswer}"]`);
        const imageURL = $answer.attr("data-image");

        $cardItem.find(elms.slotAnswerImage).prop("src", imageURL);

        $cardItem.addClass("is-filled");
        $cardItem.attr("data-answer", theAnswer);
        this.toggleCheckButton();
    }

    onClearAnswer(e, el) {
        const elms = this.elms;
        const $matchcard = $(el).parents(elms.matchCardItem).first();
        const answerId = $matchcard.attr("data-answer");
        const $answer = $(elms.matchCardSelectBtn + `[data-id=${answerId}]`);

        $answer.removeClass("is-selected");

        $matchcard
            .removeClass("is-filled")
            .removeAttr("data-answer")
            .find(elms.slotAnswerImage)
            .removeAttr("src");

        this.dischardUserAnswer(answerId);

        this.toggleCheckButton();
    }

    beforeDestroy() {
        this.playPauseAudio(null);

        if(this.hintInterval) clearInterval(this.hintInterval);
    }

    updateUserAnswer() {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        getRoomAnswers(roomId).then((data) => {
            const fbRoomAnswers = data.val() ?? {};
            const answer = this.userAnswer;

            const userAnswer = fbRoomAnswers[currentPlayerId]?.choice;
            const answerData = { ...userAnswer, ...answer };

            updateRoomAnswer(roomId, {
                [currentPlayerId]: {
                    user_id: currentPlayerId,
                    choice: answerData,
                },
            });
        });
    }

    dischardUserAnswer(answerId) {
        const roomId = this.roomId;
        const currentPlayerId = CONFIG.user.id;

        getRoomAnswers(roomId).then((data) => {
            const fbRoomAnswers = data.val() ?? {};
            const userAns = fbRoomAnswers[currentPlayerId]?.choice;

            const userAnsw = Object.keys(userAns)
                .filter((answer) => {
                    return userAns[answer] != answerId;
                })
                .reduce((answ, key) => {
                    answ[key] = userAns[key];
                    return answ;
                }, {});

            updateRoomAnswer(roomId, {
                [currentPlayerId]: {
                    user_id: currentPlayerId,
                    choice: userAnsw,
                },
            });
        });
    }

    updateUserChoicesList(answer) {
        if ($("#locationInfo-item").length < 1) return;

        const fbRoomAnswers = answer.val() ?? {};
        const players = getState().gameProgress.players;
        const template = $("#locationInfo-item").html();

        // Filter the player to not include the current user
        const onlinePlayers = players.filter(
            (player) => player.isOnline && player.userId !== CONFIG.user.id,
        );

        $(".userChoice_list").each(function () {
            const $context = $(this).parents(".js-userChoices-context");
            const hasContext = $context.length > 0;

            const slotID = hasContext
                ? $context.attr("data-slot-id")
                : undefined;
            const slotChoiceID = hasContext
                ? $context.attr("data-answer-id")
                : undefined;

            const users = onlinePlayers.filter((player) => {
                const usrID = player.userId;
                const thisPlayerAnswer = fbRoomAnswers[usrID]?.choice;

                if (typeof thisPlayerAnswer !== "object") {
                    return;
                }

                if (thisPlayerAnswer[slotID] == slotChoiceID) {
                    return player;
                }
            });

            const html = compile(template, { players: users });
            $(this).html(html);
        });
    }

    onAddDocument(e) {
        const $this = $(e.currentTarget);
        const id = $this.attr("data-id");
        const url = $this.attr("data-url");
        const title = $this.attr("data-title");
        const type = "image";

        const docObj = {
            [id]: {
                url,
                title,
                type
            },
        };

        addDocument(docObj)
            .then(() => {
                $(".js-saved-document-snackbar").addClass("is-open");
                setTimeout(() => {
                    $(".js-saved-document-snackbar").removeClass("is-open");
                }, 3000);
            })
            .catch(() => console.error("failed"));
    }

    onClickSecurityNumber(e) {
        const $digitElements = $(this.elms.digitLabel);

        if (this.currentSecurityIndex < $digitElements.length) {
            const number = $(e.currentTarget).text();
            $digitElements.eq(this.currentSecurityIndex).text(number);
            this.currentSecurityIndex++;
        }
    }

    onSubmitSecurityNumber() {
        // e.preventDefault();

        const enteredCode = $(".js-digit")
            .map(function () {
                return $(this).text();
            })
            .get()
            .join("");

        const roomID = this.roomId;
        const roomAnswers = getRoomAnswerById(roomID);
        const correctCode = roomAnswers.securityAnswer;

        if (enteredCode === correctCode) {
            $(".js-lockpad").removeClass("is-active");
            const roomStatus = "is-status-started";

            maybeUpdateRoomStatus(roomID, roomStatus);
        }

        $(".js-digit").text("0");

        this.currentSecurityIndex = 0;
    }

    onRemoveCardDrop(el) {
        const $el = $(el.currentTarget);
        const $cardDrop = $el.parent();
        const answerId = $cardDrop.attr("data-answer");

        $cardDrop.removeClass("is-dropped");

        setTimeout(() => {
            $cardDrop.find("img").attr("src", "").attr("alt", "");
            $cardDrop.find(".matchCards__options--item-title").text("");
            $cardDrop.find(".matchCards__options--item-description").text("");
        }, 500);

        const $hiddenCard = $(
            '.available-cards__item[data-id="' + answerId + '"]',
        );
        $hiddenCard.show();
        // $hiddenCard.css("display", "");
        $cardDrop.removeAttr("data-answer");
    }
    
}
